<template>
  <v-card
    class="diptych__container"
    :style="`width: ${width}; height: ${height}; borderRadius: ${borderRadius}px;`"
  >
    <div
      class="diptych__left"
      :style="`background: ${backgroundLeft}; width: ${widthLeft}; border-bottom-left-radius: ${borderRadius}px;`"
    >
      <slot name="diptych-left"></slot>
    </div>
    <div
      class="diptych__right"
      :style="`background: ${backgroundRight}; width: ${widthRight};`"
    >
      <slot name="diptych-right"></slot>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'DiptychCard',
  props: {
    backgroundLeft: { type: String, default: '' },
    backgroundRight: { type: String, default: '' },
    width: { type: String, default: '' },
    height: { type: String, default: '' },
    widthLeft: { type: String, default: '50%' },
    widthRight: { type: String, default: '50%' },
    borderRadius: { type: Number, default: 0 },
  },
};
</script>

<style lang="scss" scoped>
.diptych {
  &__container {
    display: flex;
    margin: 0 auto;
  }
  &__left {
    display: flex;
    justify-content: center;
    align-items: center;
    border-top-right-radius: 0px !important;
  }
  &__right {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
